module.exports = __webpack_public_path__ + "static/media/field.7ba5c61d.gif";